import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { SetPasswordComponent } from '@shared/components/set-password/set-password.component';

@Component({
  selector: 'app-reset-password-section',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationsComponent, SetPasswordComponent],
  templateUrl: './reset-password-section.component.html',
  styleUrls: ['./reset-password-section.component.scss'],
  providers: [ErrorHandler]
})
export class ResetPasswordSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
